import { Account } from '@/client/accounts';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { isTrialRestricted, PostHogFeatureFlags } from '@/utils/posthog';

export const useTrialRestriction = (
  account: Account | null | undefined,
): boolean => {
  const { canUseFeature, accountCanUseFeature } = useFeatureFlag();

  return (
    !!account &&
    isTrialRestricted(account) &&
    (canUseFeature(PostHogFeatureFlags.FREE_TRIAL_PLATFORM_RESTRICTIONS) ||
      accountCanUseFeature(
        PostHogFeatureFlags.FREE_TRIAL_PLATFORM_RESTRICTIONS,
        account.featureFlagAbility,
      ))
  );
};
